import { Button, ClassName, Form, IFormRender } from "@busybusy/webapp-react-ui";
import { CertificationOptions } from "__generated__/graphql";
import classNames from "classnames";
import BasicPickerFormField from "components/foundation/form-fields/BasicPickerFormField/BasicPickerFormField";
import Typography from "components/foundation/text/Typography/Typography";
import HeaderText from "containers/settings/components/HeaderText/HeaderText";
import { useToastOpen } from "contexts/ToastContext";
import { usePositionUpdate } from "hooks";
import { t } from "i18next";
import { isEqual } from "lodash";
import { v_require } from "utils/validations";
import CertificationsFormField from "../components/CertificationsFormField/CertificationsFormField";

export interface ICertificationsFormProps {
  className?: ClassName;
  positionId: string;
  onSubmit: (data: ICertificationsFormData) => void;
  currentSetting: CertificationOptions;
}

interface ICertificationsFormData {
  certifications: CertificationOptions
}

const CertificationsForm = (props: ICertificationsFormProps) => {
  const { positionId, onSubmit, currentSetting, className } = props;

  const [, update] = usePositionUpdate();
  const openToast = useToastOpen();

  async function onFormSubmit(data: ICertificationsFormData) {
    if (!isEqual(currentSetting, data.certifications)) {
      try {
        await update ({ certifications: data.certifications, id: positionId });
      } catch {
        openToast({ label: t('Something went wrong. Please try again later.') });
      }
    }

    onSubmit(data)
  }

  function renderFormFields(form: IFormRender<ICertificationsFormData>) {
    return (
      <>
        <HeaderText title={t('Certifications')} />
        <Typography tag="span" className="mb-4">
          {t(`View, create, edit, and delete certifications. Optionally allow a supervisor to view certifications for his entire crew, but only be able to manage their own`)}
        </Typography>
        <CertificationsFormField
          form={form}
          className={'mt-4'}
        />
        <Button type={'primary'} onClick={form.handleSubmit} className={'mt-6'} >{t('Update')}</Button>
      </>
    )
  }

  const classes = classNames('certifications-form', className);
  
  return (
    <div className={classes}>
      <Form
        className="mt-4"
        render={renderFormFields}
        onSubmit={onFormSubmit}
        data={{ certifications: currentSetting }}
      />
    </div>
  )
}

export default CertificationsForm;